export const Spinner = {
  baseStyle: {
    color: "accent2",
  },
  sizes: {},
  variants: {},
  defaultProps: {},
}
